<template>
  <div class="impact-level-grid">
    <table class=" z-depth-1 stripped">
      <thead>
        <tr>
          
          <th v-for="heading, index in impactCards" :key="index">
              <span @click="showTextOption(heading)" v-html="heading.name" class="heading" :style="[{color: heading.backgroundColor}]"></span>
              <button v-if="dataSelectedScore.selected === heading.name" class="btn-floating btn-small right z-depth-0 waves-effect" :style="[{backgroundColor: heading.backgroundColor}]">
              <i class="material-icons white-text">check</i></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          
          <td :ref="`def${i}`"  :class="[dataSelectedScore.selected === def.name ? 'grey lighten-4' : '', hasSeen]" v-for="def, i in impactCards" :key="(i+1) * 0.33">
            <span @click="toggleRefView(`def${i}`)" class="head-label left">Definition</span> 
            <button @click="toggleRefView(`def${i}`)" class="btn-small re waves-effect transparent z-depth-0 btn-floating right"><i class="material-icons grey-text text-darken-2">expand_more</i></button>
            <div class="clear"></div>
            <div class="definition">
              <span v-html="def.definition"></span>
            </div>
          </td>
        </tr>
          <tr>
          
          <td :ref="`cef${j}`" :class="[dataSelectedScore.selected === ex.name ? 'grey lighten-4' : '', hasSeen]" v-for="ex, j in impactCards" :key="(j+1) * 0.66">
            <span  @click="toggleRefView(`cef${j}`)" class="head-label">Examples of Impact/Consequence</span> 
            <button @click="toggleRefView(`cef${j}`)" class="btn-small re waves-effect transparent z-depth-0 btn-floating right"><i class="material-icons grey-text text-darken-2">expand_more</i></button>
            <div class="details">
                 <span v-html="ex.example"></span>
            </div>
           
          </td>
        </tr>
        <tr>
          <td :ref="`sef${j}`" :class="[dataSelectedScore.selected === sc.name ? 'grey lighten-4' : '', hasSeen]" v-for="sc, j in impactCards" :key="(j+1) * 0.99">
            <span  @click="toggleRefView(`sef${j}`)" class="head-label">Selection Guidance</span>
            <button @click="toggleRefView(`sef${j}`)" class="btn-small re waves-effect transparent z-depth-0 btn-floating right"><i class="material-icons grey-text text-darken-2">expand_more</i></button>
            <div class="details">
              <span v-html="sc.guidance"></span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="button-d" v-for="cl, l in impactCards" :key="(l+1) * 0.1333">
            <button @click="showTextOption(cl)" class="btn waves-effect btn btn-rounded indigo accent-2 waves-effect white-text">Select</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: 'impactLevelGrid',
  props:{
    impactCards:{
      type: Array
    },
    dataSelectedScore:{
      type: Object
    }
    },
  data () {
    return {
      hasSeen:'active',
    }
  },
  methods: {
    toggleRefView (e) {
      this.$refs[e][0].classList.toggle('active')
    },
     showTextOption (e){
       console.log(e)
      this.$emit('choice', e.name)
    },
  }
}
</script>
<style scoped lang="scss">
  .impact-level-grid {
    table {
      min-width: 1200px;
      border: 1px solid #e6e6e6;
      background: white;
      font-size: 15px;
      td {
        vertical-align: top;
      }
      th, td {
        padding: 15px 24px;
        border-right: 1px solid #f1f1f1;
        min-width: 220px;
      }
      .button-d {
        text-align: center;
        button {
          width: 80%;
        }
      }
    }
    .heading {
      font-size: 20px;
    }
    span {
     &.head-label {
        display: flex;
        font-weight: 600;
        font-size: 17px;
        margin-bottom: 8px;
      }
    }
  }
  .definition, .details  {
    min-height: 0;
    max-height: 0;
    overflow: hidden;
  }
  .re {
    i {
       transition: all linear .3s;
    }
  }
  .active {
  .definition, .details  {
    min-height: auto;
    max-height: 100vh;
    }
    .re {
      i {
        transform: rotateZ(-180deg);
        transition: all linear .3s;
      }
    }
  }
  td {
    position: relative;
    button {
      &.re {
        position: absolute;
        right: 8px;
        top: 8px;
      }
    }
  }

</style>
<style lang="scss">
.impact-level-grid {
  ol {
    padding-left:24px;
    li {
      margin-bottom: 6px;
    }
  }
}
</style>